import { BillingIntegrityMetricDto } from '../dtos/billing-integrity-metric.dto';

/**
 * Fleet-level context for GET billing/integrity.
 */
export class BillingIntegrityFleetSummary {
  tenantCount!: number;
  tenantsWithCapturedEventsButNoFacts!: number;
  meanOrphanedAcceptanceRate!: number | null;
  meanConversionDeltaRatio!: number | null;
  meanPostCaptureUpsellRatio!: number | null;
  meanDeclinedThenServedRate!: number | null;
  meanReversalRate!: number | null;
}

/**
 * Response for GET billing/integrity.
 */
export class BillingIntegrityResponse {
  periodFrom!: string;
  periodTo!: string;
  capturedAtFrom!: string | null;
  capturedAtTo!: string | null;
  fleet!: BillingIntegrityFleetSummary;
  records!: BillingIntegrityMetricDto[];
}
